import type { FixedRateAppClickSource } from '../events'

import { trackAnalyticsEvent } from '../track'

/** Impression denominator for the topnav click. */
export function trackFixedRateNavViewed() {
  trackAnalyticsEvent('fixed_rate_nav_viewed', {})
}

/** Impression denominator for the market-page callout click. */
export function trackFixedRateCalloutViewed(params: { chainId: number; marketId: string }) {
  trackAnalyticsEvent('fixed_rate_callout_viewed', {
    chain_id: params.chainId,
    market_id: params.marketId
  })
}

export function trackFixedRateAppClicked(params: {
  source: FixedRateAppClickSource
  // Only the market callout has a market; the topnav and banner omit these.
  chainId?: number
  marketId?: string
}) {
  trackAnalyticsEvent('fixed_rate_app_clicked', {
    source: params.source,
    ...(params.chainId !== undefined ? { chain_id: params.chainId } : {}),
    // Lowercased to match the impression, so the two join per market.
    ...(params.marketId !== undefined ? { market_id: params.marketId.toLowerCase() } : {})
  })
}

export function trackFixedRateBannerDismissed() {
  trackAnalyticsEvent('fixed_rate_banner_dismissed', {})
}
